import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowsPage.PromotionListItem', {
    button: 'Try now for 14 days',
});
